<div class="page-container">
  <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id="flameGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fb923c"/>
        <stop offset="0.55" stop-color="#f97316"/>
        <stop offset="1" stop-color="#dc2626"/>
      </linearGradient>
      <linearGradient id="iceGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#e0f2fe"/>
        <stop offset="0.5" stop-color="#7dd3fc"/>
        <stop offset="1" stop-color="#38bdf8"/>
      </linearGradient>
    </defs>
  </svg>
  <div class="rosters-container" *ngIf="rosters.length > 0 && !isSmallScreen">
    <div class="sticky-top-bar">
      <h2>Vertical Talent Roster</h2>
      <button class="site-button" (click)="ShowAddToRosterDialog()">Add To Roster</button>
    </div>
    <div class="filter-row"></div>
    <div class="filter-row"><input class="name-filter" type="text" [(ngModel)]="nameFilter" placeholder="Filter by name..."></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="filter-row"><select class="filter-select genre-filter" [(ngModel)]="genreFilter"><option value="all">All</option><option *ngFor="let genre of genres" [value]="genre">{{ genre }}</option></select></div>
    <div class="filter-row"></div>
    <div class="filter-row"><select class="filter-select" [(ngModel)]="exclusiveFilter"><option value="both">Both</option><option value="yes">Yes</option><option value="no">No</option></select></div>
    <div class="filter-row"><select class="filter-select" [(ngModel)]="activeFilter"><option value="both">Both</option><option value="yes">Yes</option><option value="no">No</option></select></div>
    <div class="filter-row"><select class="filter-select" [(ngModel)]="featuredFilter"><option value="both">Both</option><option value="yes">Yes</option><option value="no">No</option></select></div>
    <div class="filter-row"></div>
    <div class="filter-row"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header centered" style="grid-column: span 2">Commission</div>
    <div class="header centered" style="grid-column: span 3">Platform Links</div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header"></div>
    <div class="header centered mediakit-header">MediaKit</div>
    <div class="header">Name</div>
    <div class="header centered">Heat</div>
    <div class="header centered">Rates</div>
    <div class="header" style="text-align: center">In</div>
    <div class="header" style="text-align: center">Out</div>
    <div class="header" style="text-align: center">TT</div>
    <div class="header" style="text-align: center">IG</div>
    <div class="header" style="text-align: center">YT</div>
    <div class="header">Genre</div>
    <div class="header">Notes</div>
    <div class="header">Exclusive</div>
    <div class="header">Active</div>
    <div class="header">Featured</div>
    <div class="header">Sign Date</div>
    <div class="header">Vertical Email</div>
    <ng-container *ngFor="let roster of rosters">
      <div class="cell" *ngIf="isRosterVisible(roster)"><a class="mediakit-avatar" [href]="'/mediakit/' + roster.id" target="_blank" title="Open media kit"><img class="profile-image" alt="" [src]="roster.id | profileImage" referrerpolicy="no-referrer" (error)="$any($event.target).style.visibility = 'hidden'"></a></div>
      <div class="cell cell-name" *ngIf="isRosterVisible(roster)">
        <div class="name-row">
          <a href="#" [routerLink]="['/agent/rosters', roster.id]">{{roster.name}}</a>
          <ng-container *ngTemplateOutlet="calendarButton; context: { $implicit: roster }"></ng-container>
        </div>
        <div class="handle-row" *ngIf="roster.tiktokHandle">TT: <a href="https://tiktok.com/{{roster.tiktokHandle}}" target="_blank">{{roster.tiktokHandle}}</a></div>
        <div class="handle-row" *ngIf="roster.instagramHandle">IG: <a href="https://instagram.com/{{roster.instagramHandle}}" target="_blank">{{roster.instagramHandle}}</a></div>
        <div class="handle-row" *ngIf="roster.youtubeHandle">YT: <a href="https://youtube.com/{{roster.youtubeHandle}}" target="_blank">{{roster.youtubeHandle}}</a></div>      </div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">
        <ng-container *ngTemplateOutlet="heatIcons; context: { $implicit: roster }"></ng-container>
      </div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">
        <ng-container *ngTemplateOutlet="rateIcon; context: { $implicit: roster }"></ng-container>
      </div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">{{roster.inboundCommission}}</div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">{{roster.outboundCommission}}</div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">
        <svg *ngIf="roster.tt" class="oauth-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="TikTok linked"><title>TikTok linked</title><circle cx="12" cy="12" r="10" fill="#22c55e"/><path d="M7.5 12.5l3 3 6-6.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
        <svg *ngIf="!roster.tt" class="oauth-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="TikTok not linked"><title>TikTok not linked</title><circle cx="12" cy="12" r="10" fill="#ef4444"/><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="white" stroke-width="2.2" stroke-linecap="round"/></svg>
      </div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">
        <svg *ngIf="roster.ig" class="oauth-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="Instagram linked"><title>Instagram linked</title><circle cx="12" cy="12" r="10" fill="#22c55e"/><path d="M7.5 12.5l3 3 6-6.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
        <svg *ngIf="!roster.ig" class="oauth-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="Instagram not linked"><title>Instagram not linked</title><circle cx="12" cy="12" r="10" fill="#ef4444"/><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="white" stroke-width="2.2" stroke-linecap="round"/></svg>
      </div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)">
        <svg *ngIf="roster.yt" class="oauth-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="YouTube linked"><title>YouTube linked</title><circle cx="12" cy="12" r="10" fill="#22c55e"/><path d="M7.5 12.5l3 3 6-6.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
        <svg *ngIf="!roster.yt" class="oauth-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="YouTube not linked"><title>YouTube not linked</title><circle cx="12" cy="12" r="10" fill="#ef4444"/><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="white" stroke-width="2.2" stroke-linecap="round"/></svg>
      </div>
      <div class="cell" *ngIf="isRosterVisible(roster)">
        <textarea rows="2" [(ngModel)]="roster.genre" (blur)="onGenreChange(roster, roster.genre)" style="width:110px;resize:both;font-size:inherit"></textarea>
      </div>
      <div class="cell" *ngIf="isRosterVisible(roster)">
        <textarea rows="2" [(ngModel)]="roster.notes" (blur)="onNotesChange(roster, roster.notes)" style="width:220px;resize:both;font-size:inherit"></textarea>
      </div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)"><a href="#" (click)="toggleBooleanField(roster, 'exclusive'); $event.preventDefault()">{{roster.exclusive | yesNo}}</a></div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)"><a href="#" (click)="toggleBooleanField(roster, 'active'); $event.preventDefault()">{{roster.active | yesNo}}</a></div>
      <div class="cell centered" *ngIf="isRosterVisible(roster)"><a href="#" (click)="toggleBooleanField(roster, 'featured'); $event.preventDefault()">{{roster.featured | yesNo}}</a></div>
      <div class="cell" *ngIf="isRosterVisible(roster)">
        <input type="date" class="date-input" [value]="toDateInput(roster.signDate)" (change)="onSignDateChange(roster, $event)">
      </div>
      <div class="cell" *ngIf="isRosterVisible(roster)">{{roster.verticalEmail}}</div>
    </ng-container>
  </div>
</div>


<!-- Phones: one tile per roster instead of the grid table -->
<div class="roster-mobile" *ngIf="rosters.length > 0 && isSmallScreen">
  <div class="mobile-header">
    <div class="mobile-title-row">
      <h2>Roster <span class="mobile-count">{{visibleRosterCount}}</span></h2>
      <button class="site-button" (click)="ShowAddToRosterDialog()">Add To Roster</button>
    </div>
    <div class="mobile-search-row">
      <input class="mobile-search" type="text" [(ngModel)]="nameFilter" placeholder="Search name or handle...">
      <button type="button" class="filters-toggle" [class.open]="mobileFiltersOpen" (click)="toggleMobileFilters()">
        Filters
        <span class="toggle-arrow" [class.arrow-up]="mobileFiltersOpen" [class.arrow-down]="!mobileFiltersOpen"></span>
      </button>
    </div>
    <div class="mobile-filters" *ngIf="mobileFiltersOpen">
      <label class="mobile-filter-field">
        <span>Genre</span>
        <select [(ngModel)]="genreFilter"><option value="all">All</option><option *ngFor="let genre of genres" [value]="genre">{{ genre }}</option></select>
      </label>
      <label class="mobile-filter-field">
        <span>Exclusive</span>
        <select [(ngModel)]="exclusiveFilter"><option value="both">Both</option><option value="yes">Yes</option><option value="no">No</option></select>
      </label>
      <label class="mobile-filter-field">
        <span>Active</span>
        <select [(ngModel)]="activeFilter"><option value="both">Both</option><option value="yes">Yes</option><option value="no">No</option></select>
      </label>
      <label class="mobile-filter-field">
        <span>Featured</span>
        <select [(ngModel)]="featuredFilter"><option value="both">Both</option><option value="yes">Yes</option><option value="no">No</option></select>
      </label>
    </div>
  </div>

  <div class="roster-tiles">
    <ng-container *ngFor="let roster of rosters">
      <div class="roster-tile" *ngIf="isRosterVisible(roster)" [class.inactive-tile]="!roster.active">
        <div class="tile-top">
          <a class="tile-avatar-link" [routerLink]="['/agent/rosters', roster.id]">
            <img class="profile-image" alt="profile image" [src]="roster.id | profileImage" referrerpolicy="no-referrer">
          </a>
          <div class="tile-identity">
            <div class="name-row">
              <a class="tile-name" [routerLink]="['/agent/rosters', roster.id]">{{roster.name}}</a>
              <ng-container *ngTemplateOutlet="calendarButton; context: { $implicit: roster }"></ng-container>
            </div>
            <div class="tile-handles">
              <a *ngIf="roster.tiktokHandle" href="https://tiktok.com/{{roster.tiktokHandle}}" target="_blank">TT: {{roster.tiktokHandle}}</a>
              <a *ngIf="roster.instagramHandle" href="https://instagram.com/{{roster.instagramHandle}}" target="_blank">IG: {{roster.instagramHandle}}</a>
              <a *ngIf="roster.youtubeHandle" href="https://youtube.com/{{roster.youtubeHandle}}" target="_blank">YT: {{roster.youtubeHandle}}</a>            </div>
          </div>
          <div class="tile-indicators">
            <ng-container *ngTemplateOutlet="heatIcons; context: { $implicit: roster }"></ng-container>
            <ng-container *ngTemplateOutlet="rateIcon; context: { $implicit: roster }"></ng-container>
          </div>
        </div>

        <div class="tile-genres" *ngIf="genreTags(roster).length > 0">
          <span class="genre-pill" [ngClass]="genreColorClass(tag)" *ngFor="let tag of genreTags(roster)">{{ tag }}</span>
        </div>

        <div class="tile-notes" *ngIf="roster.notes">{{roster.notes}}</div>

        <div class="tile-stats">
          <div class="tile-stat"><span class="tile-label">Comm. In/Out</span><span>{{roster.inboundCommission}} / {{roster.outboundCommission}}</span></div>
          <div class="tile-stat">
            <span class="tile-label">Linked</span>
            <span class="link-badges">
              <span class="link-badge" [class.linked]="roster.tt">TT</span>
              <span class="link-badge" [class.linked]="roster.ig">IG</span>
              <span class="link-badge" [class.linked]="roster.yt">YT</span>
            </span>
          </div>
          <div class="tile-stat" *ngIf="roster.signDate"><span class="tile-label">Signed</span><span>{{roster.signDate | date:'MM/dd/yy'}}</span></div>
          <div class="tile-stat" *ngIf="roster.verticalEmail"><span class="tile-label">Email</span><span class="tile-email">{{roster.verticalEmail}}</span></div>
        </div>

        <!-- Tap to toggle, same as the Yes/No links in the table -->
        <div class="tile-toggles">
          <button type="button" class="toggle-chip" [class.on]="roster.exclusive" (click)="toggleBooleanField(roster, 'exclusive')">Exclusive</button>
          <button type="button" class="toggle-chip" [class.on]="roster.active" (click)="toggleBooleanField(roster, 'active')">Active</button>
          <button type="button" class="toggle-chip" [class.on]="roster.featured" (click)="toggleBooleanField(roster, 'featured')">Featured</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Shared by the table and the tiles -->
<ng-template #calendarButton let-roster>
  <span *ngIf="roster.enableCalendarEvents" class="calendar-icon"
        title="Task due dates are synced to this creator's Google Calendar" aria-label="Calendar events enabled" role="img">
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.8"/>
      <path d="M3.5 10h17M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
  </span>
</ng-template>

<ng-template #heatIcons let-roster>
  <span class="heat-icons" *ngIf="heatLevel(roster) as h" [title]="heatTooltip(roster)">
    <ng-container *ngIf="h > 0">
      <svg *ngFor="let _ of range(h)" class="heat-icon" viewBox="0 0 24 24" width="13" height="15" aria-hidden="true">
        <path d="M12.963 2.286a.75.75 0 0 0-1.071-.136 9.742 9.742 0 0 0-3.539 6.176 7.547 7.547 0 0 1-1.705-1.715.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248z" fill="url(#flameGrad)"/>
        <path d="M15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 0 1 1.925-3.546 3.75 3.75 0 0 1 3.255 3.718z" fill="#fde047"/>
      </svg>
    </ng-container>
    <ng-container *ngIf="h < 0">
      <svg *ngFor="let _ of range(-h)" class="heat-icon" viewBox="0 0 24 24" width="13" height="14" aria-hidden="true">
        <rect x="4.5" y="4.5" width="15" height="15" rx="3.5" fill="url(#iceGrad)" stroke="#bae6fd" stroke-width="1"/>
        <path d="M8 8l2.4-1.4M7.6 11.6l4.4-2.7" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" opacity="0.85"/>
      </svg>
    </ng-container>
  </span>
</ng-template>

<ng-template #rateIcon let-roster>
  <ng-container [ngSwitch]="ratesStatus(roster)">
    <svg *ngSwitchCase="'complete'" class="rate-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="All rates defined"><title>All rates defined</title><circle cx="12" cy="12" r="10" fill="#22c55e"/><path d="M7.5 12.5l3 3 6-6.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
    <svg *ngSwitchCase="'some'" class="rate-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="Missing Rates"><title>Missing Rates</title><circle cx="12" cy="12" r="10" fill="#f59e0b"/><path d="M12 7v6.5" stroke="white" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="16.8" r="1.25" fill="white"/></svg>
    <svg *ngSwitchCase="'all'" class="rate-icon" viewBox="0 0 24 24" width="22" height="22" aria-label="No rates defined"><title>No rates defined</title><circle cx="12" cy="12" r="10" fill="#ef4444"/><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="white" stroke-width="2.2" stroke-linecap="round"/></svg>
  </ng-container>
</ng-template>


<div class="center-text" *ngIf="rosters.length == 0 && !loading">
  <h1>No Roster Found</h1>
  <button (click)="ShowAddToRosterDialog()">Add To Roster</button>
</div>

<div *ngIf="rosters.length == 0 && loading">
  Loading...
</div>

<app-dialog [(visible)]="showAddRosterDialog">
  <div class="form-header">Add Creator to Roster</div>
  <div>
    <div class="exclusive-toggle">
      <label>
        <input type="checkbox" [(ngModel)]="newRosterModel.exclusive">
        Exclusive
      </label>
    </div>
    <div class="form-item">
      <span>Name <span class="required">*</span></span>
      <span><input [(ngModel)]="newRosterModel.name" required></span>
    </div>
    <div class="form-item">
      <span>Source</span>
      <span>
        <select [(ngModel)]="newRosterModel.source" title="source" id="source">
          <option value="">Not Set</option>
          <option *ngFor="let u of sourceUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
        </select>
      </span>
    </div>
    <div class="form-item">
      <span>Agent <span class="required">*</span></span>
      <span>
        <select [(ngModel)]="newRosterModel.agent" title="agent" id="agent" required>
          <option value="">- Select -</option>
          <option *ngFor="let u of agentUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
        </select>
      </span>
    </div>
    <div class="form-item">
      <span>Coordinator <span class="required">*</span></span>
      <span>
        <select [(ngModel)]="newRosterModel.coordinator" title="coordinator" id="coordinator" required>
          <option value="">- Select -</option>
          <option *ngFor="let u of agentUsers" [value]="u.id">{{u.firstName}} {{u.lastName}}</option>
        </select>
      </span>
    </div>
    <div class="form-item">
      <span>Gender <span class="required">*</span></span>
      <span>
        <select [(ngModel)]="newRosterModel.gender" title="gender" id="gender" required>
          <option value="">- Select -</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
      </span>
    </div>
    <div class="form-item">
      <span>Phone</span>
      <span><input [(ngModel)]="newRosterModel.phone"></span>
    </div>
    <div class="form-item">
      <span>Genre</span>
      <span><textarea [(ngModel)]="newRosterModel.genre" title="genre" id="genre" rows="3" placeholder="e.g. Pets&#10;Lifestyle"></textarea></span>
    </div>
    <div class="form-item">
      <span>TikTok Handle</span>
      <span><input [(ngModel)]="newRosterModel.tiktokHandle"></span>
    </div>
    <div class="form-item">
      <span>Instagram Handle</span>
      <span><input [(ngModel)]="newRosterModel.instagramHandle"></span>
    </div>
    <ng-container *ngIf="newRosterModel.exclusive">
      <div class="exclusive-section-label">- Exclusive Fields -</div>
      <div class="form-item">
        <span>Sign Date</span>
        <span><input type="date" [(ngModel)]="newRosterModel.signDate"></span>
      </div>
      <div class="form-item">
        <span>Vertical Email <span class="required">*</span></span>
        <span><input type="email" [(ngModel)]="newRosterModel.verticalEmail" required></span>
      </div>
    </ng-container>
  </div>
  <div class="center-text">
    <button (click)="AddToRosterClick()" [disabled]="!canAddToRoster">Add To Roster</button>
  </div>
</app-dialog>
